import { ApiResponseType, ChanelType } from 'src/shared';
import { HttpHandler } from '../HttpHandler';
import { environment } from 'src/enviroments';
import { MessageResponseBase } from 'stream-chat';

export const getChatRooms = async (): Promise<ApiResponseType<ChanelType[]>> => {
  const { data: roomsData } = await HttpHandler({
    method: 'GET',
    url: `${environment.CHAT_APP_API_URL}/client/rooms`,
  });

  return roomsData;
};

export const sendMessage = async (
  to: string,
  message: string
): Promise<ApiResponseType<{ message: MessageResponseBase; to: string }>> => {
  const { data: roomsData } = await HttpHandler({
    method: 'POST',
    url: `${environment.CHAT_APP_API_URL}/client/send-message/${to}`,
    data: {
      message,
    },
  });

  return roomsData;
};
